import {css} from 'styled-components';

export const DETAILS_PANEL_WIDTH = 448;

export const DETAILS_PANEL_WIDTH_PX = `${DETAILS_PANEL_WIDTH}px`;

export const PANEL_HEIGHT_WITHOUT_HEADER = 'calc(100vh - 66px - 48px)';

export const vendorDetailsPanelStyles = css`
  .vendor-details {
    .vendor-details-panel-body {
      max-height: calc(100vh - (66px + 56px + 24px * 2 + 8px));
    }
  }
`;
